<div class="row step-header">
  <div class="col col-100">
    <h3>Create your account</h3>
    <p>It lets you manage payments, get help and sign in to the Starry app</p>
  </div>
</div>
<div class="card-layout no-border text-dark">
  <div class="row">
     <div class="col col-100">
       <label for="email">Email*</label>
       <div class="input-wrap">
        <input id="email" value="{{ email }}" name="email" type="email" autocorrect="off" placeholder="johnny@appleseed.com">
        </div>
      <div class="js-emailErrorContainer">{{{ emailErrorMarkup }}}</div>
    </div>
  </div>
  <div class="row">
    <div class="col col-100">
      <label for="password">Password <span class="subext">(must be at least 8 characters long)*</label>
      <input id="password" value="{{ password }}" name="password" type="password" placeholder="************" autocorrect="off" autofocus>
    </div>
    <input type="submit" class="hidden">
  </div>
</div>
